module.exports = __webpack_public_path__ + "img/linkedin.91a11ddc.svg";